import { IconButton, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useFilterContext, useViewContext, useWeightContext } from '../../context';
import { lloydConstants } from '../../Constants';
import { buildViewCsv, downloadCsv } from '../../exportView';

const DownloadButton = () => {
	const anchorRef = React.useRef(null);
	const [open, setOpen] = useState(false);

	const view = useViewContext();
	const filters = useFilterContext();
	const weights = useWeightContext();

	const downloadOriginalData = () => {
		window.location.href = './data/wrp_all_data.zip';
		setOpen(false);
	};

	// The published file answers "show me the data". This answers "show me the numbers
	// behind the thing I am looking at", which is the question someone actually has
	// once they have built a view.
	const downloadCurrentView = () => {
		const csv = buildViewCsv({
			rows: view.rows,
			year: view.year,
			weights,
			filters: {
				Gender: filters.gender,
				'Age group': filters.ageGroup,
				'Education level': filters.educationLevel,
				Income: filters.income,
				'Employment status': filters.employmentStatus,
				Urbanicity: filters.urbanicity,
			},
			weightingIsPublished: view.weightingIsPublished,
			minSampleSize: lloydConstants.minSampleSize,
			withheld: view.withheld,
		});

		downloadCsv(`resilience-index-${view.year}.csv`, csv);
		setOpen(false);
	};

	return (
		<>
			<Tooltip title="Download" placement="bottom" arrow>
				<span>
					<IconButton color="primary" size={'large'} onClick={() => setOpen(true)} ref={anchorRef}>
						<span className="material-symbols-outlined" style={{ fontSize: 24 }}>
							download
						</span>
					</IconButton>
				</span>
			</Tooltip>

			<Menu anchorEl={anchorRef.current} open={open} onClose={() => setOpen(false)}>
				<MenuItem onClick={downloadCurrentView} disabled={!view.rows.length}>
					<ListItemText
						primary="This view, as CSV"
						secondary={`${view.rows.length} countries, with margins of error and the filters applied`}
					/>
				</MenuItem>
				<MenuItem onClick={downloadOriginalData}>
					<ListItemText
						primary="Full dataset"
						secondary="Every respondent, all three waves"
					/>
				</MenuItem>
			</Menu>
		</>
	);
};

export default DownloadButton;
